import React from 'react';
import { Icon } from './Icon.js';
export const IconBanFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "1.752", y: "8.254", width: "14.487", height: "1.5", transform: "translate(-3.732 8.998) rotate(-45)", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M9,17c-4.411,0-8-3.589-8-8S4.589,1,9,1s8,3.589,8,8-3.589,8-8,8Zm0-14.5c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5,6.5-2.916,6.5-6.5-2.916-6.5-6.5-6.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconBanFill18.js.map